import axios from 'axios';

const API = axios.create({ baseURL: '/api' });

// Voeg JWT token automatisch toe aan elke request
API.interceptors.request.use(config => {
  const token = localStorage.getItem('dive_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

export const getDives          = ()       => API.get('/dives').then(r => r.data);
export const createDive        = (data)   => API.post('/dives', data).then(r => r.data);
export const getDiveSuggestions = ()      => API.get('/dives/suggestions').then(r => r.data);
export const getDive        = (id)     => API.get(`/dives/${id}`).then(r => r.data);
export const getDiveProfile = (id)     => API.get(`/dives/${id}/profile`).then(r => r.data);
export const updateDive     = (id, d)  => API.put(`/dives/${id}`, d).then(r => r.data);
export const deleteDive     = (id)     => API.delete(`/dives/${id}`).then(r => r.data);
export const getStats       = ()       => API.get('/stats').then(r => r.data);
export const getSites       = ()       => API.get('/sites').then(r => r.data);

export const importUDDF = (file) => {
  const form = new FormData();
  form.append('file', file);
  return API.post('/import/uddf', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};

export const getUsers      = ()          => API.get('/users').then(r => r.data);
export const createUser    = (data)      => API.post('/users', data).then(r => r.data);
export const deleteUser    = (id)        => API.delete(`/users/${id}`).then(r => r.data);
export const resetPassword = (id, pw)   => API.put(`/users/${id}/password`, { password: pw }).then(r => r.data);

export const importOceanic = (file) => {
  const form = new FormData();
  form.append('file', file);
  return API.post('/import/oceanic', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};

export const getDivePhotos   = (diveId)         => API.get(`/dives/${diveId}/photos`).then(r => r.data);
export const uploadDivePhotos = (diveId, files) => {
  const form = new FormData();
  files.forEach(f => form.append('photos', f));
  return API.post(`/dives/${diveId}/photos`, form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
};
export const deleteDivePhoto    = (diveId, photoId)           => API.delete(`/dives/${diveId}/photos/${photoId}`).then(r => r.data);
export const updatePhotoCaption = (diveId, photoId, caption)  => API.patch(`/dives/${diveId}/photos/${photoId}`, { caption }).then(r => r.data);

// Generieke lookups
export const getLookup       = (cat)        => API.get(`/settings/lookup/${cat}`).then(r => r.data);
export const createLookupItem = (cat, value) => API.post(`/settings/lookup/${cat}`, { value }).then(r => r.data);
export const deleteLookupItem = (cat, id)    => API.delete(`/settings/lookup/${cat}/${id}`).then(r => r.data);

// Buddies
export const getBuddies    = ()       => API.get('/settings/buddies').then(r => r.data);
export const createBuddy   = (name)   => API.post('/settings/buddies', { name }).then(r => r.data);
export const deleteBuddy   = (id)     => API.delete(`/settings/buddies/${id}`).then(r => r.data);

export const uploadBuddyPhoto = (id, formData) =>
  API.post(`/settings/buddies/${id}/photo`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
export const deleteBuddyPhoto = (id) => API.delete(`/settings/buddies/${id}/photo`).then(r => r.data);
export const uploadBuddyHandtekening = (id, formData) =>
  API.post(`/settings/buddies/${id}/handtekening`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
export const deleteBuddyHandtekening = (id) => API.delete(`/settings/buddies/${id}/handtekening`).then(r => r.data);

// Zichtbaarheid
export const getVisibility       = ()            => API.get('/settings/visibility').then(r => r.data);
export const createVisibility    = (value_m, label) => API.post('/settings/visibility', { value_m, label }).then(r => r.data);
export const deleteVisibility    = (id)          => API.delete(`/settings/visibility/${id}`).then(r => r.data);

export const getShareToken      = ()  => API.get('/settings/share-token').then(r => r.data);
export const regenerateShareToken = () => API.post('/settings/share-token/regenerate').then(r => r.data);

export const getPublicStats = (token) => API.get(`/public/${token}/stats`).then(r => r.data);
export const getPublicDives = (token) => API.get(`/public/${token}/dives`).then(r => r.data);

// Visherkenning
export const identifyPhoto       = (diveId, photoId)           => API.post(`/dives/${diveId}/photos/${photoId}/identify`).then(r => r.data);
export const deletePhotoSpecies  = (diveId, photoId, body)     => API.delete(`/dives/${diveId}/photos/${photoId}/species`, { data: body }).then(r => r.data);
export const addManualSpecies    = (diveId, photoId, body)     => API.post(`/dives/${diveId}/photos/${photoId}/species`, body).then(r => r.data);
export const updateSpeciesDutchName = (diveId, photoId, body) => API.patch(`/dives/${diveId}/photos/${photoId}/species`, body).then(r => r.data);
export const getPhotoSpecies  = (diveId, photoId) => API.get(`/dives/${diveId}/photos/${photoId}/species`).then(r => r.data);
export const searchSpecies    = (q)               => API.get('/species', { params: { q } }).then(r => r.data);
export const getTopSpecies      = ()              => API.get('/species/top').then(r => r.data);
// latin_name is de primaire unieke sleutel; dutch_name als fallback voor soorten zonder latijnse naam
export const getSpeciesDetails  = (latin, dutch)  => API.get('/species/details', {
  params: latin ? { latin } : { name: dutch },
}).then(r => r.data);

// App-instellingen
export const getAppSetting    = (key)             => API.get(`/settings/app/${key}`).then(r => r.data);
export const setAppSetting    = (key, value)      => API.put(`/settings/app/${key}`, { value }).then(r => r.data);
export const getSpeciesStats  = (threshold)       => API.get('/settings/species-stats', { params: { threshold } }).then(r => r.data);

// Uitrusting (gear)
export const listGear   = ()         => API.get('/gear').then(r => r.data);
export const createGear = (data)     => API.post('/gear', data).then(r => r.data);
export const updateGear = (id, data) => API.put(`/gear/${id}`, data).then(r => r.data);
export const deleteGear = (id)       => API.delete(`/gear/${id}`).then(r => r.data);

// Brevetten
export const listBrevets  = ()              => API.get('/brevets').then(r => r.data);
export const createBrevet = (formData)      => API.post('/brevets', formData).then(r => r.data);
export const updateBrevet = (id, data)      => API.put(`/brevets/${id}`, data).then(r => r.data);
export const deleteBrevet = (id)            => API.delete(`/brevets/${id}`).then(r => r.data);
export const uploadBrevetPhoto = (id, side, formData) =>
  API.post(`/brevets/${id}/photo/${side}`, formData).then(r => r.data);

// Verzekeringen
export const listVerzekeringen      = ()              => API.get('/verzekeringen').then(r => r.data);
export const createVerzekering      = (formData)      => API.post('/verzekeringen', formData).then(r => r.data);
export const updateVerzekering      = (id, data)      => API.put(`/verzekeringen/${id}`, data).then(r => r.data);
export const deleteVerzekering      = (id)            => API.delete(`/verzekeringen/${id}`).then(r => r.data);
export const uploadVerzekeringPhoto = (id, side, fd)  => API.post(`/verzekeringen/${id}/photo/${side}`, fd).then(r => r.data);

// Stempels & handtekeningen per duik
export const getDiveStamps   = (diveId)                   => API.get(`/dives/${diveId}/stamps`).then(r => r.data);
export const uploadDiveStamp = (diveId, formData)         => API.post(`/dives/${diveId}/stamps`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
export const updateStampName = (diveId, stampId, name)   => API.patch(`/dives/${diveId}/stamps/${stampId}`, { dive_center: name }).then(r => r.data);
export const deleteDiveStamp = (diveId, stampId)          => API.delete(`/dives/${diveId}/stamps/${stampId}`).then(r => r.data);
export const getPublicDiveStamps = (token, diveId)        => API.get(`/public/${token}/dives/${diveId}/stamps`).then(r => r.data);

// Database backup
export const listBackups      = ()                => API.get('/backup').then(r => r.data);
export const createBackup     = ()                => API.post('/backup/create').then(r => r.data);
export const restoreBackup    = (filename)        => API.post('/backup/restore', { filename }).then(r => r.data);
export const deleteBackup     = (filename)        => API.delete(`/backup/${encodeURIComponent(filename)}`).then(r => r.data);
